import axios from 'axios';
import { API_BASE_URL } from '../config';

const AUTH_API_URL = '/api/auth';

// Create axios instance with base URL
const apiClient = axios.create({
  baseURL: `${API_BASE_URL}${AUTH_API_URL}`,
  timeout: 10000,
});

class AuthService {
  async authenticateWithGoogle(googleToken) {
    try {
      console.log('Sending authentication request with token:', googleToken);
      const response = await apiClient.post('/google', {
        token: googleToken
      });
      console.log('Authentication response:', response);
      return response;
    } catch (error) {
      console.error('Authentication error:', error);
      throw new Error(error.response?.data?.message || error.message || 'Authentication failed');
    }
  }

  async register(name, email, password) {
    try {
      console.log('Sending registration request with email:', email);
      const response = await apiClient.post('/register', {
        name,
        email,
        password
      });
      console.log('Registration response:', response);
      return response;
    } catch (error) {
      console.error('Registration error:', error);
      const fieldErrors = error.response?.data?.errors;
      const message = fieldErrors
        ? Object.values(fieldErrors).join('. ')
        : error.response?.data?.message || error.message || 'Registration failed';
      throw new Error(message);
    }
  }

  async login(email, password) {
    try {
      console.log('Sending login request with email:', email);
      const response = await apiClient.post('/login', {
        email,
        password
      });
      console.log('Login response:', response);
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw new Error(error.response?.data?.message || error.message || 'Login failed');
    }
  }
}

export default new AuthService();
